import React, { ReactNode } from 'react';
import { ALL, deviceTypeByDeliverableOptions, deviceTypeOptions } from '~/features/base/constants/filterOptions';
import { FormattedMessage } from 'react-intl';
import { selectionByValue } from '~/features/base/utils/selectUtils';
import SelectOTA from '~/features/base/components/forms/ota/SelectOTA';

interface DeviceTypeSelectProps {
    deliverableType?: string;
    hasError?: boolean
    value: string;
    onChange: Function;
    withLabel?: boolean;
    label?: string | ReactNode;
    withAllOption?: boolean;
}

const DeviceTypeSelect: React.FC<DeviceTypeSelectProps> = ({
    hasError,
    deliverableType,
    value,
    onChange,
    withLabel,
    label,
    withAllOption
}) => {

    const deviceTypes = deliverableType ? deviceTypeByDeliverableOptions[deliverableType] : !withAllOption ? deviceTypeOptions : [...deviceTypeOptions, {
        id: ALL,
        label: 'ALL devices types',
        value: ALL,
    }];
    const options = selectionByValue(value)(deviceTypes);

    return (
        <div>
            {!withLabel && <label className='control-label'>
                <FormattedMessage id='intl-msg:deviceType'/>
            </label>}
            <SelectOTA
                hasError={hasError}
                options={options}
                label={withLabel && label}
                onChange={onChange}
                placeholder={<FormattedMessage
                    id='intl-msg:deviceType.prompt'/>}/>
        </div>
    )
}

export default DeviceTypeSelect;
